import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import { logIn, setDados, fetch } from './actions'
import { LoadingScreenMain } from './components/Diversos';

import MenuRedirects from './containers/Shared/MenuRedirects';
import Login from './containers/Auth/Login';
import Logout from './containers/Auth/Logout';
import NotFound from './containers/Shared/NotFound';
import ErrorScreen from './components/ErrorScreen';

import Clientes from './containers/Clientes/Clientes';
import Contingencia from './containers/Contingencia/Contingencia';
import Contadores from './containers/Contadores/Contadores';
import Logs from './containers/Logs/Log';
 

function Main(props) {
    const [erroIni, setErroIni] = useState(null);
    const [loading, setLoading] = useState(true);
  
    useEffect(() => {
      if(!props.auth.tokenId, props.tokenId){
        props.logIn({ user: props.user, tokenId: props.tokenId, refreshToken: props. refreshToken });
      }
      else{
        setLoading(false);
      }
    }, []);

    useEffect(() => {
 
      if(props.auth.tokenId){
          setLoading(false);
      }
    }, [props.auth.tokenId]);

 
    if(erroIni){
      return <ErrorScreen />
    }

    if(loading){
      return <LoadingScreenMain />
    }

    let dados = null;

    if(!props.auth.user) {
      dados = (<Switch>
        <Route exact path="/login" component={Login} />     
        {/* <Redirect to="/login" /> */}
        <Route component={Login}/>
      </Switch>)
    }
    else {
       dados = (
      <Switch>        
        <Route exact path="/menuredirect/:id" component={MenuRedirects} />
        <Route exact path="/clientes" component={Clientes}/>
        <Route exact path="/contingencias" component={Contingencia}/>
        <Route exact path="/contadores" component={Contadores}/>
        <Route exact path="/logs" component={Logs}/>
        <Route exact path="/login" component={Login} />
        <Route exact path="/logout" component={Logout} />      
        <Redirect exact from="/" to="/clientes" />
        <Route component={NotFound}/>
      </Switch>)
    }

    return (
      <div className="container" id="container-principal">
        <div>
          <Router>
            {dados}
          </Router>
        </div>
      </div>
    );
}

const mapStateToProps = (state) => {
  return { auth: state.auth, dados: state.dados  };
};

export default connect(mapStateToProps, { logIn, fetch, setDados })(Main);
